import React from "react"
import './App.scss';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux'
import thunk from 'redux-thunk';
import rootReducer from './reducers/rootReducer';
import Routes from './components/Routes'
import { Layout } from 'antd';
import styled from 'styled-components'

const store = createStore(
  rootReducer,
  applyMiddleware(thunk)
);

const CalendarLayout = styled(Layout)`
  background-color: transparent;

  @media(max-width: 768px) {
    padding: 16px;
  }
`

class App extends React.Component {

  componentDidMount() {
    debugger
    const { hostname } = window.location;
    const faviconLink = document.getElementById('favicon');

    const umbrellaFavicon = 'https://umbrella-platform.s3.us-east-1.amazonaws.com/static/favicon.png';
    const huboneFavicon = 'https://umbrella-platform.s3.us-east-1.amazonaws.com/static/hubone_favicon.ico';

    if (!faviconLink) return;

    if (hostname === 'umbrellaus.com' || hostname === 'umbrella-staging.com') {
      faviconLink.href = umbrellaFavicon;
    } else if (hostname === 'huboneos.com' || hostname === 'hubone-staging.com') {
      faviconLink.href = huboneFavicon;
    } else {
      
      faviconLink.href = huboneFavicon;
    }
  }

  render () {
    return (
      <div className="body-container">
        <CalendarLayout>
          <div className='main-app-container'>
            <Provider store={store}>
              <Routes />
            </Provider>
          </div>
        </CalendarLayout>
      </div>
    );
  }
}

export default App
